import React, { useEffect, useState } from "react";
import { useConfig } from "../../context/ConfigContext";
import "../Styles/Redirects.css";

export default function RedirectsTab() {
  const { config } = useConfig();

  const [redirects, setRedirects] = useState([]);

  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [destination, setDestination] = useState("");

  const [loading, setLoading] = useState(false);
  const [loadingRedirects, setLoadingRedirects] = useState(true);

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const apiUrl = config?.apiUrl;

  const loadRedirects = async () => {
    if (!apiUrl) return;

    setLoadingRedirects(true);
    setError("");

    try {
      const res = await fetch(`${apiUrl}/admin/redirects`, {
        method: "GET",
        credentials: "include",
      });

      const data = await res.json().catch(() => []);

      if (!res.ok) {
        throw new Error(data.error || "Failed to load redirects");
      }

      setRedirects(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setError(err.message || "Failed to load redirects");
    } finally {
      setLoadingRedirects(false);
    }
  };

  useEffect(() => {
    loadRedirects();
  }, [apiUrl]);

  const addRedirect = async (e) => {
    e.preventDefault();

    setError("");
    setMessage("");

    if (!name.trim() || !slug.trim() || !destination.trim()) {
      setError("Please fill in all fields.");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${apiUrl}/admin/redirects`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          slug,
          destination,
        }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data.error || "Failed to create redirect");
      }

      setMessage("Redirect added successfully.");

      setName("");
      setSlug("");
      setDestination("");

      await loadRedirects();
    } catch (err) {
      console.error(err);
      setError(err.message || "Failed to create redirect");
    } finally {
      setLoading(false);
    }
  };

  const deleteRedirect = async (id, redirectName) => {
    const confirmed = window.confirm(
      `Delete the redirect "${redirectName}"?\n\nThis cannot be undone.`
    );

    if (!confirmed) return;

    setError("");
    setMessage("");

    try {
      const res = await fetch(`${apiUrl}/admin/redirects/${id}`, {
        method: "DELETE",
        credentials: "include",
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data.error || "Failed to delete redirect");
      }

      setMessage("Redirect deleted successfully.");

      await loadRedirects();
    } catch (err) {
      console.error(err);
      setError(err.message || "Failed to delete redirect");
    }
  };

  return (
    <div className="redirects-admin">

      {/* ADD REDIRECT */}
      <section className="card">
        <div className="redirects-header">
          <div>
            <h2>🔗 URL Redirects</h2>
            <p className="muted">
              Create short BB3 Memorial URLs that redirect visitors to external
              auction pages or other websites.
            </p>
          </div>
        </div>

        <form className="redirect-form" onSubmit={addRedirect}>

          <label>
            <span>Redirect Name</span>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Signed Cricket Bat"
            />
          </label>

          <label>
            <span>BB3 URL</span>

            <div className="slug-input">
              <span>bb3memorial.co.uk</span>

              <input
                type="text"
                value={slug}
                onChange={(e) => setSlug(e.target.value.toLowerCase())}
                placeholder="/cricket-bat"
              />
            </div>
          </label>

          <label>
            <span>Destination URL</span>

            <input
              type="url"
              value={destination}
              onChange={(e) => setDestination(e.target.value)}
              placeholder="https://auctionwebsite.com/item/123"
            />
          </label>

          <button
            type="submit"
            className="btn primary"
            disabled={loading}
          >
            {loading ? "Adding..." : "Add Redirect"}
          </button>
        </form>

        {message && (
          <div className="redirect-message success">
            {message}
          </div>
        )}

        {error && (
          <div className="redirect-message error">
            {error}
          </div>
        )}
      </section>


      {/* EXISTING REDIRECTS */}
      <section className="card">
        <div className="redirects-list-header">
          <h2>Existing Redirects</h2>

          <button
            type="button"
            className="btn ghost"
            onClick={loadRedirects}
            disabled={loadingRedirects}
          >
            {loadingRedirects ? "Refreshing..." : "Refresh"}
          </button>
        </div>

        {loadingRedirects ? (
          <p className="muted">Loading redirects...</p>
        ) : redirects.length === 0 ? (
          <p className="muted">
            No redirects have been created yet.
          </p>
        ) : (
          <div className="redirect-list">

            {redirects.map((redirect) => (
              <div
                className="redirect-item"
                key={redirect._id}
              >

                <div className="redirect-details">

                  <div className="redirect-name">
                    {redirect.name}
                  </div>

                  <div className="redirect-url">
                    <strong>
                      bb3memorial.co.uk{redirect.slug}
                    </strong>
                  </div>

                  <div className="redirect-destination">
                    → {redirect.destination}
                  </div>

                </div>

                <div className="redirect-actions">

                  <a
                    href={redirect.slug}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn ghost"
                  >
                    Test
                  </a>

                  <button
                    type="button"
                    className="btn danger"
                    onClick={() =>
                      deleteRedirect(
                        redirect._id,
                        redirect.name
                      )
                    }
                  >
                    Delete
                  </button>

                </div>

              </div>
            ))}

          </div>
        )}
      </section>

    </div>
  );
}